import { render, staticRenderFns } from "./PlansList.vue?vue&type=template&id=fcfbdc22&scoped=true"
import script from "./PlansList.vue?vue&type=script&lang=js"
export * from "./PlansList.vue?vue&type=script&lang=js"
import style0 from "./PlansList.vue?vue&type=style&index=0&id=fcfbdc22&prod&scoped=true&lang=css"
import style1 from "./PlansList.vue?vue&type=style&index=1&id=fcfbdc22&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcfbdc22",
  null
  
)

export default component.exports